import { render } from "./driving_licence_detail.vue?vue&type=template&id=6cf64294&scoped=true&ts=true"
import script from "./driving_licence_detail.vue?vue&type=script&lang=ts"
export * from "./driving_licence_detail.vue?vue&type=script&lang=ts"

import "./driving_licence_detail.vue?vue&type=style&index=0&id=6cf64294&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf64294"]])

export default __exports__